import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  DynamicFieldPicker,
  DynamicFieldPickerSchema,
  DynamicFieldPickerValidation,
} from './DynamicFieldPicker';

export const DynamicFieldPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'DynamicFieldPicker',
    component: DynamicFieldPicker,
    schema: DynamicFieldPickerSchema,
    validation: DynamicFieldPickerValidation,
  }),
);
